var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("pulse-loader", {
        staticClass: "text-center",
        attrs: {
          loading: _vm.loadingObject.loadingCodes,
          color: _vm.$constants.LOADING_COLOR,
        },
      }),
      _vm._v(" "),
      !_vm.loadingObject.loadingCodes
        ? _c("div", [
            _c("table", { staticClass: "table table-sm mt-0 table-hover" }, [
              _c(
                "tbody",
                [
                  _vm._l(_vm.records.rk, function (code, drugId, i) {
                    return _vm.hasLink(code?.details)
                      ? [
                          _c("tr", [
                            _c(
                              "td",
                              {
                                staticClass: "m_w_350",
                                attrs: {
                                  rowspan:
                                    +(
                                      Object.values(code?.details ?? {})
                                        .length ?? 1
                                    ) + 1,
                                },
                              },
                              [
                                _vm._v(
                                  _vm._s(code.drug?.title) + "\n          "
                                ),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _vm._l(code?.details ?? {}, function (link, id, ii) {
                            return _c("tr", [
                              _c("td", [
                                _c(
                                  "a",
                                  {
                                    attrs: {
                                      href: `https://uteka.ru/product/${link.suppliers_link_data}`,
                                      target: "_blank",
                                    },
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "icon-fa icon-fa-globe",
                                    }),
                                  ]
                                ),
                                _vm._v(
                                  " " +
                                    _vm._s(link.suppliers_link_data) +
                                    "\n          "
                                ),
                              ]),
                              _vm._v(" "),
                              _c(
                                "td",
                                [
                                  (code.drug?.suppliers_prices ?? []).find(
                                    (p) => p.detail_id === +id
                                  )
                                    ? _c("UtekaStatistics", {
                                        attrs: {
                                          stats: (
                                            code.drug?.suppliers_prices ?? []
                                          ).find((p) => p.detail_id === +id),
                                        },
                                      })
                                    : _vm._e(),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "td",
                                [
                                  _c("CreateWatchTask", {
                                    ref: "watchTask_Uteka",
                                    refInFor: true,
                                    attrs: {
                                      task: _vm.savedTasks[id],
                                      detailId: id,
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("td"),
                            ])
                          }),
                        ]
                      : _vm._e()
                  }),
                  _vm._v(" "),
                  _vm._m(0),
                  _vm._v(" "),
                  _c("tr", [
                    _c(
                      "td",
                      { attrs: { rowspan: _vm.records["003sm"].length + 2 } },
                      [_vm._v(_vm._s(_vm.drug?.title))]
                    ),
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.records["003sm"], function (code) {
                    return _c("tr", [
                      _c("td", [
                        _c(
                          "a",
                          {
                            attrs: {
                              href: `https://uteka.ru/product/${code.value}`,
                              target: "_blank",
                            },
                          },
                          [_c("i", { staticClass: "icon-fa icon-fa-globe" })]
                        ),
                        _vm._v(" " + _vm._s(code.value) + "\n        "),
                      ]),
                      _vm._v(" "),
                      _c("td"),
                      _vm._v(" "),
                      _c(
                        "td",
                        [
                          _c("CreateWatchTask", {
                            ref: "watchTask_Uteka",
                            refInFor: true,
                            attrs: {
                              task: _vm.savedTasks[code.id],
                              detailId: code.id,
                              "detail-type": "003",
                            },
                          }),
                        ],
                        1
                      ),
                    ])
                  }),
                  _vm._v(" "),
                  _c("tr", [
                    _c("td"),
                    _vm._v(" "),
                    _c("td"),
                    _vm._v(" "),
                    _c(
                      "td",
                      [
                        _c("Create003WatchTask", {
                          ref: "watchTask_003",
                          attrs: { task: _vm.savedTasks[_vm.drug.id] },
                        }),
                      ],
                      1
                    ),
                  ]),
                ],
                2
              ),
            ]),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("tr", [
      _c("td", { attrs: { colspan: "10" } }, [
        _c("strong", [_vm._v("Коды для справочной 003")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }